import { StoreEntityType } from 'ngx-unificator/store';
import { UserType } from '../types/user.type';


export const userStore: StoreEntityType<UserType> = {
  address: '',
  all_payment_methods_verified: false,
  auth_fields_missed: [],
  autologin_link: '',
  autoregistered: false,
  banking_details: [],
  can_issue_bonuses: false,
  city: '',
  confirmed_at: '',
  country: '',
  created_at: '',
  currency: '',
  currency_symbol: '',
  current_sign_in_at: '',
  date_of_birth: '',
  deposit_bonus_code: '',
  email: '',
  first_name: '',
  gender: '',
  id: 0,
  language: '',
  last_name: '',
  license_name: '',
  middle_name: '',
  mobile_phone: '',
  postal_code: '',
  profession: '',
  receive_promos: false,
  receive_sms_promos: false,
  sow_questionnaire_expires_at: '',
  sow_questionnaire_requested: false,
  statuses: [],
  two_factor_enabled: false,
  user_account_status: '',
  verified: false,
  auth: false,
  nickname: '',
  lottery: null,
  mobile_phone_without_dial_code: ''
};

export type UserStoreEntity = typeof userStore;
